import React from "react";
import { DataTableColumn } from "@sscs/ui";
import { GroupsIcon } from "@sscs/ui/icons";
import { PERMISSION } from "Constants";
import { useAllowedTo } from "Hooks";
import useShowAddMemberColumn from "../../hooks/useShowAddMemberColumn";
import { SortGroups } from "../../types";
import styles from "./groupsTableHeader.module.scss";

/** The table's container title, rendered via the `DataTable` `title` prop. */
export const GroupsTableTitle = (): React.JSX.Element => (
  <span className={styles["table-title"]}>
    <GroupsIcon className={styles["title-icon"]} />
    Groups
  </span>
);

/**
 * Column definitions for the groups table, resolving the permission-gated
 * columns via `useAllowedTo`. Passed to `DataTable`'s `columns` prop.
 */
export const useGroupsColumns = (): DataTableColumn<
  SortGroups["property"]
>[] => {
  const showAddMemberColumn = useShowAddMemberColumn();
  const canSetDefault = useAllowedTo({
    permissions: [PERMISSION.SET_GROUP_AS_DEFAULT],
  });
  const canModifyGroups = useAllowedTo({
    permissions: [PERMISSION.CREATE_GROUP, PERMISSION.DELETE_GROUP],
  });

  return [
    {
      id: "expand",
      label: "Members",
      width: "100px",
    },
    {
      id: "group_name",
      label: "Group name",
      sortProperty: "group_name",
      width: "100%",
    },
    {
      id: "member_count",
      label: "Member count",
      sortProperty: "member_count",
      startReverse: true,
      align: "center",
      width: "160px",
    },
    {
      id: "default",
      label: "Default",
      align: "center",
      width: "150px",
      hidden: !canSetDefault,
    },
    {
      id: "add-member",
      label: "",
      align: "center",
      width: "140px",
      hidden: !showAddMemberColumn,
    },
    {
      id: "actions",
      label: "Actions",
      align: "center",
      width: "100px",
      hidden: !canModifyGroups,
    },
  ];
};
